import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import envConfig from "../../../utils/env.config";

export const upsellingApiSlice = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: `${envConfig.baseUrl}/items/upselling-items`,
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as any;
      const { token } = state.userInfo;

      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }

      headers.set("Content-Type", "application/json");

      return headers;
    },
  }),
  keepUnusedDataFor: 30,
  endpoints: (build) => ({
    getUpsellingItems: build.query<
      any,
      { restaurantId: string; franchiseId: number }
    >({
      query: ({ restaurantId, franchiseId }) =>
        `?restaurantId=${restaurantId}&franchiseId=${franchiseId}`,
      keepUnusedDataFor: 5,
    }),
  }),
});

export const { useGetUpsellingItemsQuery } = upsellingApiSlice;
